import { seoOgTwitterTitle } from './SeoStore';

export const updateSeoOgTwitterTitle = (value) => seoOgTwitterTitle.update(oldValue => value);
